import { render, staticRenderFns } from "./AccessHistory.vue?vue&type=template&id=30a4cd03&scoped=true&"
import script from "./AccessHistory.vue?vue&type=script&lang=js&"
export * from "./AccessHistory.vue?vue&type=script&lang=js&"
import style0 from "./AccessHistory.vue?vue&type=style&index=0&id=30a4cd03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4cd03",
  null
  
)

export default component.exports